var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropertyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 80,
    viewBox: "0 0 160 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9384",
    "data-name": "Rectangle 9384",
    width: 160,
    height: 80,
    transform: "translate(0.06)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_585",
    "data-name": "Mask Group 585",
    transform: "translate(-0.06)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(9.607 4.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-122",
    transform: "translate(0 68.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_254",
    "data-name": "Line 254",
    d: "M140,.5H0v-1H140Z",
    transform: "translate(0 0.5)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57303",
    "data-name": "Group 57303",
    transform: "translate(14.595 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57302",
    "data-name": "Group 57302",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9370",
    "data-name": "Rectangle 9370",
    width: 93.88,
    height: 49.773,
    transform: "translate(10.783 18.973)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70105",
    "data-name": "Path 70105",
    d: "M409.228,279.613H306.852c-.092,0-.17-.088-.188-.211a.291.291,0,0,1,.115-.293l19.545-15.256a3.592,3.592,0,0,1,1.84-.524h62.122a3.53,3.53,0,0,1,1.714.453L409.3,279.1a.273.273,0,0,1,.146.306C409.428,279.544,409.33,279.636,409.228,279.613Z",
    transform: "translate(-298.64 -255.551)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70106",
    "data-name": "Path 70106",
    d: "M0-17.914,29.7-37.631,59.784-17.914V30.508H0Z",
    transform: "translate(5.984 38.238)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_593",
    "data-name": "Subtraction 593",
    d: "M.215,24c-.1,0-.188-.115-.21-.273a.424.424,0,0,1,.128-.4l34.633-23a1.469,1.469,0,0,1,1.857,0l34.633,23a.423.423,0,0,1,.128.4c-.021.158-.11.273-.21.273H65.23L36.623,5.5a1.469,1.469,0,0,0-1.857,0L6.158,24H.215Z",
    transform: "translate(0)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70109",
    "data-name": "Path 70109",
    d: "M0,0H22.595V24.558H0Z",
    transform: "translate(72.172 31.951)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70110",
    "data-name": "Path 70110",
    d: "M0,0H32.834V24.558H0Z",
    transform: "translate(19.277 31.951)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57300",
    "data-name": "Group 57300",
    transform: "translate(74.899 34.454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9371",
    "data-name": "Rectangle 9371",
    width: 7.121,
    height: 5.23,
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9372",
    "data-name": "Rectangle 9372",
    width: 7.121,
    height: 5.23,
    transform: "translate(10.02)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9373",
    "data-name": "Rectangle 9373",
    width: 7.121,
    height: 12.277,
    transform: "translate(0 7.579)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9374",
    "data-name": "Rectangle 9374",
    width: 7.121,
    height: 12.277,
    transform: "translate(10.02 7.579)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57301",
    "data-name": "Group 57301",
    transform: "translate(21.991 34.454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9375",
    "data-name": "Rectangle 9375",
    width: 7.121,
    height: 5.23,
    transform: "translate(0 0)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9376",
    "data-name": "Rectangle 9376",
    width: 7.121,
    height: 5.23,
    transform: "translate(20.286 0)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9377",
    "data-name": "Rectangle 9377",
    width: 7.121,
    height: 5.23,
    transform: "translate(10.143 0)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9378",
    "data-name": "Rectangle 9378",
    width: 7.121,
    height: 12.277,
    transform: "translate(0 7.579)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9379",
    "data-name": "Rectangle 9379",
    width: 7.121,
    height: 12.277,
    transform: "translate(20.286 7.579)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9380",
    "data-name": "Rectangle 9380",
    width: 7.121,
    height: 12.277,
    transform: "translate(10.143 7.579)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9381",
    "data-name": "Rectangle 9381",
    width: 3.783,
    height: 7.259,
    transform: "translate(86.76 5.243)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9382",
    "data-name": "Rectangle 9382",
    d: "M0,0H27.038a0,0,0,0,1,0,0V0a1.193,1.193,0,0,1-1.193,1.193H1.193A1.193,1.193,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(70.052 55.924)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9383",
    "data-name": "Rectangle 9383",
    d: "M0,0H39.04a0,0,0,0,1,0,0V0a1.193,1.193,0,0,1-1.193,1.193H1.193A1.193,1.193,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(15.751 55.924)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIcon);
export default __webpack_public_path__ + "static/media/propertyIcon.c07858befebf93ca722497e78009fdc7.svg";
export { ForwardRef as ReactComponent };